import type { Components } from '@mui/material/styles/components';

export const MuiButtonBase: Components['MuiButtonBase'] = {
  defaultProps: {
    disableRipple: true,
    disableTouchRipple: true,
  },
};
